import { EntryPoint } from '../../apply/index.js';
import { Method, Payload } from '../../generic-types/index.js';

export enum IntegrationDeliveryKeys {
  ORACLE_OUTBOUND = 'ORACLE_OUTBOUND',
  SITS_OUTBOUND = 'SITS_OUTBOUND',
  ELLUCIAN_OUTBOUND = 'ELLUCIAN_OUTBOUND',
}

export enum Integrations {
  ORACLE = 'oracle',
  SITS = 'sits',
  ELLUCIAN = 'ellucian',
}

export type CreateDelivery = {
  userId: string;
  sentAt: string;
  method: Method;
  url: string;
  headers?: Record<string, string>;
  statusCode?: number;
  responseText?: string;
  applicationId?: string;
  error?: {
    message: string;
  };
} & Payload;

export type Delivery = CreateDelivery & {
  p_key: string;
  s_key: string;
  docType: IntegrationDeliveryKeys;
  ttl: number;
};

export type OffsetKey = Record<string, unknown>;
export type Paginated<T> = {
  records: T[];
  next?: OffsetKey;
};

export type Deliveries = Paginated<Delivery>;

export interface ListOutboundRequest {
  uni: string;
  page?: OffsetKey;
}

export interface ListUserOutboundRequest {
  uni: string;
  userId: string;
  page?: OffsetKey;
}

export interface DeliveriesPathParam {
  integration: Integrations;
  uni: string;
  userId?: string;
}
export interface RetryDeliveriesPathParam extends DeliveriesPathParam {
  userId: string;
  deliverySortKey: string;
}

export const EntryPointNumber = {
  [EntryPoint.Year0]: 0,
  [EntryPoint.Year1]: 1,
  [EntryPoint.Year2]: 2,
  [EntryPoint.Year3]: 3,
  [EntryPoint.Year4]: 4,
  [EntryPoint.Year5]: 5,
  [EntryPoint.Year6]: 6,
} as const satisfies Record<EntryPoint, number>;
